import { computeModalData } from "../../lib/threeLib";
import { TOOTH_RAW_TYPE } from "../constant/toothConstant";
import gumMatrixDB from "../db/gumMatrixDB";
import stageDB from "../db/stageDB";
import toothMatrixDB from "../db/toothMatrixDB";
import toothNumberDB from "../db/toothNumberDB";
import toothStageRawDB from "../db/toothStageRawDB";
import iprModel from "../model/iprModel";
import toothModel from "../model/toothModel";
import toothPartsModel from "../model/toothPartsModel";

const getToothModelByToothNumber = (toothNumber) => {
  const { model } = toothModel.getToothModelByToothNumber(toothNumber);
  return model;
};

const getToothMatrixByStageNumberAndToothGumTypeAndToothIndex = (
  stageNumber,
  toothGumType,
  toothIndex
) => {
  const stageDO = stageDB.getStageDOFromStageNumberAndToothGumType(
    stageNumber,
    toothGumType
  );

  const { activeStageNumber } = stageDO;

  const toothMatrixDO =
    toothMatrixDB.getToothMatrixDOByStageNumberAndToothGumType(
      activeStageNumber,
      toothGumType
    );

  if (toothMatrixDO) {
    const toothMatrixList = toothMatrixDO.toothMatrixList;
    return toothMatrixList[toothIndex - 1];
  }

  throw new Error("Tooth matrix not found");
};

const getToothVisibleByStageNumberAndToothGumTypeAndToothIndex = (
  stageNumber,
  toothGumType,
  toothIndex
) => {
  const stageDO = stageDB.getStageDOFromStageNumberAndToothGumType(
    stageNumber,
    toothGumType
  );

  const { activeStageNumber } = stageDO;

  const toothStageRawDO =
    toothStageRawDB.getToothStageRawDOByStageNumberAndToothGumTypeAndRawType(
      activeStageNumber,
      toothGumType,
      TOOTH_RAW_TYPE.VISIBILITY
    );
  if (toothStageRawDO) {
    const visibilityData = toothStageRawDO.rawData;
    const visible = visibilityData[toothIndex - 1];
    return visible;
  }

  throw new Error("Tooth visibility not found");
};

const getToothVisibleListByStageNumberAndToothGumType = (
  stageNumber,
  toothGumType
) => {
  const stageDO = stageDB.getStageDOFromStageNumberAndToothGumType(
    stageNumber,
    toothGumType
  );

  const { activeStageNumber } = stageDO;

  const toothStageRawDO =
    toothStageRawDB.getToothStageRawDOByStageNumberAndToothGumTypeAndRawType(
      activeStageNumber,
      toothGumType,
      TOOTH_RAW_TYPE.VISIBILITY
    );

  if (toothStageRawDO) {
    return toothStageRawDO.rawData;
  }

  throw new Error("Tooth visibility not found");
};

const getToothNumberListByToothGumType = (
  toothGumType
) => {
  const toothNumberList = toothNumberDB.getToothNumberListByGumType(toothGumType);
  return toothNumberList ? toothNumberList.toothNumberList : [];
};

const getToothMovementsByStageNumberAndToothGumType = (
  stageNumber,
  toothGumType
) => {
  const stageDO = stageDB.getStageDOFromStageNumberAndToothGumType(
    stageNumber,
    toothGumType
  );

  const { activeStageNumber } = stageDO;

  const gumMatrixDO = gumMatrixDB.getGumMatrixDOByStageNumberAndToothGumType(
    activeStageNumber,
    toothGumType
  );

  const initGumMatrixDO =
    gumMatrixDB.getGumMatrixDOByStageNumberAndToothGumType(1, toothGumType);

  const toothMatrixDO =
    toothMatrixDB.getToothMatrixDOByStageNumberAndToothGumType(
      activeStageNumber,
      toothGumType
    );

  const initToothMatrixDO =
    toothMatrixDB.getToothMatrixDOByStageNumberAndToothGumType(
      1,
      toothGumType
    );

    const toothMatrixList = toothMatrixDO.toothMatrixList

    const movementList = toothMatrixList.map((toothMatrix, index) => {
      const toothIndex = index + 1
      const toothNumber = toothNumberDB.getToothNumberByGumTypeAndToothIndex(toothGumType, toothIndex)
      const toothMatrixWithNormal = computeModalData(
        initToothMatrixDO.toothMatrixList[index],
        toothMatrix,
        toothNumber,
        initGumMatrixDO.gumMatrix,
        gumMatrixDO.gumMatrix
      );

      return toothMatrixWithNormal;
    });

  return movementList;
};

const getToothMovementByStageNumberAndToothNumber = (
  stageNumber,
  toothNumber
) => {
  const toothModelDO = toothModel.getToothModelByToothNumber(toothNumber);
  const { toothIndex, toothGumType } = toothModelDO;

  const stageDO = stageDB.getStageDOFromStageNumberAndToothGumType(
    stageNumber,
    toothGumType
  );

  const { activeStageNumber } = stageDO;

  const gumMatrixDO = gumMatrixDB.getGumMatrixDOByStageNumberAndToothGumType(
    activeStageNumber,
    toothGumType
  );

  const initGumMatrixDO =
    gumMatrixDB.getGumMatrixDOByStageNumberAndToothGumType(1, toothGumType);

  const toothMatrixDO =
    toothMatrixDB.getToothMatrixDOByStageNumberAndToothGumTypeAndToothIndex(
      activeStageNumber,
      toothGumType,
      toothIndex
    );

  const initToothMatrixDO =
    toothMatrixDB.getToothMatrixDOByStageNumberAndToothGumTypeAndToothIndex(
      1,
      toothGumType,
      toothIndex
    );

  const initToothMatrix = initToothMatrixDO;
  const toothMatrix = toothMatrixDO;

  const initGumMatrix = initGumMatrixDO.gumMatrix;
  const gumMatrix = gumMatrixDO.gumMatrix;

  const movement = computeModalData(
    initToothMatrix,
    toothMatrix,
    toothNumber,
    initGumMatrix,
    gumMatrix
  );

  return movement;
};

const getIPRModelListByStageNumberAndToothGumType = (
  stageNumber,
  toothGumType
) => {
  const stageDO = stageDB.getStageDOFromStageNumberAndToothGumType(
    stageNumber,
    toothGumType
  );
  
  const { activeStageNumber } = stageDO;

  const iprModelList = iprModel.getIPRModelListByStageNumberAndToothGumType(
    activeStageNumber,
    toothGumType
  );

  return iprModelList;
};

const getIPRModelList = () => {
  const iprModelList = iprModel.getIPRModelList();
  return iprModelList;
};

const getToothPartsModelListByToothNumber = (toothNumber) => {
  return toothPartsModel.getToothPartsModelListByToothNumber(toothNumber);
};

const getToothModelList = () => {
  const toothModelList = toothModel.getToothModelList();
  return toothModelList;
};

export default {
  getToothModelByToothNumber,
  getToothModelList,
  getToothMatrixByStageNumberAndToothGumTypeAndToothIndex,
  getToothPartsModelListByToothNumber,
  getToothVisibleByStageNumberAndToothGumTypeAndToothIndex,
  getToothVisibleListByStageNumberAndToothGumType,
  getIPRModelListByStageNumberAndToothGumType,
  getToothMovementByStageNumberAndToothNumber,
  getToothMovementsByStageNumberAndToothGumType,
  getToothNumberListByToothGumType,
  getIPRModelList,
};
